// { lat: 55.752511, lng: 37.623162 }

export const BASE_URL = process.env.BASE_URL;

// export const DEFAULT_MAP_CENTER = { lat: 41.716664, lng: 44.78333 };

export const DEFAULT_MAP_CENTER = { lat: 55.752511, lng: 37.623162 };
